export class OrgInfo {
    ID:number;
CLIENT_ID:number;
IMAGE_URL:string;
DESCRIPTION:string;

}